import styled, { css } from 'styled-components';
import Typography from '../../../../typography';
const footerLegalMenuItemStyles = () => css `
	text-align: center;
`;
export const StyledFooterLegalMenuItem = styled.li `
	${footerLegalMenuItemStyles}
`;
const footerLegalMenuItemLinkStyles = ({ theme, tagName, }) => css `
	color: ${theme.colors.dark.textLink};
	text-decoration: none;

	${tagName === 'a'
    ? css `
				&:hover,
				&:active {
					color: ${theme.colors.dark.textLink};
					text-decoration: none;
				}

				&:focus-visible {
					outline: ${theme.borderWidth.m}px solid ${theme.colors.highlight.borderFocus};
					border-radius: ${theme.borderRadius.m}px;
				}
			`
    : css `
				/* override the Typography styles */
				&&& {
					&:hover {
						color: ${theme.colors.dark.textLink};
						text-decoration: none;
					}
				}
			`}
`;
export const StyledFooterLegalMenuItemLink = styled(Typography).attrs({
    variant: 'footer-link',
}) `
	${footerLegalMenuItemLinkStyles}
`;
